module.exports = __webpack_public_path__ + "img/sniperrifle.16391f81.png";